// Brand lockup: "Founder Bottleneck" as the primary product name,
// endorsed by the KOS umbrella brand ("by KOS"). Never render as
// "KOS Founder Bottleneck".
export const BrandLockup = ({ nameClass = "text-base", tmClass = "text-[9px]", suffix = null }) => (
  <span className="inline-flex flex-col leading-none" data-testid="brand-lockup">
    <span className={`font-display ${nameClass} font-semibold tracking-tight text-[#0B0E14]`}>
      Founder Bottleneck<sup className={`text-[#A68A56] ${tmClass}`}>™</sup>{suffix}
    </span>
    <span className="text-[9px] font-medium uppercase tracking-[0.28em] text-[#A68A56] mt-1.5">
      by KOS
    </span>
  </span>
);
